import * as React from "react";
import JSONTree from 'react-json-tree';
import { v4 as uuidv4 } from 'uuid';
import ObjectPath from "object-path";

import '../styles/JsonTree.css';

import Commons from "../utils/Commons";
import DataCache from "../resources/data/DataCache";

// MAYBE : handle tree without immersing (request on objectgroup name click)
export default class EntitiesTree extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            sTreeKey: uuidv4(),
            selected: []
        };
        this.componentKey = uuidv4().concat("_");
    }

    componentDidMount()
    {
        const aPreSelected = this.props.selected;

        if (aPreSelected && 0 < aPreSelected.length)
        {
            this.performPreSelection(aPreSelected);
        }
    }

    checkboxChange = (aEvent, aParams) =>
    {
        const aKeyPath = aParams.keyPath.reverse();
        const aTargetData = ObjectPath.get(this.props.treeData, aKeyPath);

        const selectChildren = (aData, bChecked, sDataKey) =>
        {
            const modifyState = (sId, aDataItem, sDataItemKey) =>
            {
                if (sId)
                {
                    if (bChecked)
                    {
                        if (0 > this.state.selected.findIndex(aSelected =>
                        {
                            return (aSelected.id === sId) || sId.includes(aSelected.id);
                        }))
                        {
                            this.state.selected.push({
                                id: sId,
                                isEntity: aDataItem.isEntity,
                                name: sDataItemKey
                            });
                        }
                    } else
                    {
                        const nIdxToRemove = this.state.selected.findIndex(aSelectedId =>
                        {
                            return (aSelectedId.id === sId) || (sId.includes(aSelectedId.id));
                        });
                        if (0 <= nIdxToRemove)
                        {
                            this.state.selected.splice(nIdxToRemove, 1);
                        }
                    }
                }
            }
            let sIdGen = this.generateCheckboxId(aData);
            modifyState(sIdGen, aData, sDataKey);

            for (let sKey in aData)
            {
                switch (sKey)
                {
                    case "isEntity":
                        continue;
                        break;
                    case "id":
                        continue;
                        break;
                    case "iconUrl":
                        continue;
                        break;
                    default:
                        if (aData[sKey].hasOwnProperty("isEntity") && aData[sKey].isEntity)
                        {
                            let sIdGenEntity = this.generateCheckboxId(aData[sKey]);
                            modifyState(sIdGenEntity, aData[sKey], sKey);
                        } else
                        {
                            selectChildren(aData[sKey], bChecked, sKey);
                        }
                        break;
                }
            }
        }

        if (this.props.multiSelect)
        {
            selectChildren(aTargetData, aEvent.target.checked, aKeyPath[aKeyPath.length - 1]);
        } else
        {
            if (aEvent.target.checked)
            {
                this.state.selected = [{
                    id: aEvent.target.id,
                    name: aKeyPath[aKeyPath.length - 1],
                    isEntity: aTargetData.isEntity
                }];
            } else
            {
                this.state.selected = [];
            }
        }

        if (this.props.selectionCallback && "function" === typeof this.props.selectionCallback)
        {
            const aSelectedItems = JSON.parse(JSON.stringify(
                this.state.selected.filter(aItem =>
                {
                    return (aItem && aItem.hasOwnProperty("isEntity") && aItem.isEntity);
                })
            ));
            const aSelectedEntities = aSelectedItems.map(aSelected =>
            {
                let aSelectedToRet = aSelected;
                if (aSelectedToRet.hasOwnProperty("id") && aSelectedToRet.id.startsWith(this.componentKey))
                {
                    aSelectedToRet.id = aSelectedToRet.id.slice(this.componentKey.length);
                }
                if (aSelectedToRet.hasOwnProperty("isEntity"))
                {
                    delete aSelectedToRet.isEntity;
                }
                return aSelectedToRet
            });
            this.props.selectionCallback(aSelectedEntities);
        }
        this.setState({});
        return;

    }

    generateCheckboxId = (aObj) =>
    {
        return aObj.hasOwnProperty("id") ? this.componentKey.concat(Commons.removeCurlyBracketsFromId(aObj.id)) : null;
    }

    performPreSelection = (aPreSelected) =>
    {
        aPreSelected.forEach(aItem =>
        {
            if (aItem.hasOwnProperty("id") && aItem.id && aItem.hasOwnProperty("name") && aItem.name)
            {
                if (!this.state.selected.find(aSelectedItem =>
                {
                    return aSelectedItem.id === aItem.id;
                }))
                {
                    this.state.selected.push({
                        name: aItem.name,
                        id: aItem.id,
                        isEntity: true
                    })
                }
            }
        });
        if (this.props.selectionCallback && "function" === typeof this.props.selectionCallback)
        {
            const aPreSelectedItems = JSON.parse(JSON.stringify(
                this.state.selected.filter(aItem =>
                {
                    return (aItem && aItem.hasOwnProperty("isEntity") && aItem.isEntity);
                })
            ));
            this.props.selectionCallback(aPreSelectedItems);
        }
    }

    aTreeTheme = {
        base00: '#FFFFFF',
        base01: '#000000',
        base02: '#000000',
        base03: '#000000',
        base04: '#000000',
        base05: '#000000',
        base06: '#000000',
        base07: '#000000',
        base08: '#000000',
        base09: '#000000',
        base0A: '#000000',
        base0B: '#000000',
        base0C: '#000000',
        base0D: '#000000',
        base0E: '#000000',
        base0F: '#000000'
    };

    render()
    {
        const aTreeData = JSON.parse(JSON.stringify(this.props.treeData));
        const bMultiSelect = this.props.multiSelect;
        const shouldExpandNode = (keyPath, data, level) => this.props?.toggle || false; // Expand all nodes
        return (
            <div className="JsonTree__container">
                {aTreeData ?
                    <JSONTree
                        shouldExpandNode={shouldExpandNode}
                        key={this.state.sTreeKey}
                        data={aTreeData}
                        hideRoot={true}
                        theme={{
                            extend: this.aTreeTheme,
                            arrowSign: {
                                fontFamily: "Segoe UI Symbol, sansSerif",
                                color: "#AFAFAF"
                            },
                            tree: {
                                fontSize: "12px"
                            }
                        }}
                        invertTheme={false}
                        postprocessValue={(value) =>
                        {
                            if (value.hasOwnProperty('id'))
                            {
                                delete value['id'];
                            }
                            if (value.hasOwnProperty('isEntity'))
                            {
                                delete value['isEntity'];
                            }
                            if (value.hasOwnProperty('iconUrl'))
                            {
                                delete value['iconUrl'];
                            }
                            return value;
                        }}
                        labelRenderer={(keyPath) =>
                        {
                            keyPath.reverse();
                            const aTreeDataItem = ObjectPath.get(aTreeData, keyPath);
                            const aOrgTreeDataItem = ObjectPath.get(this.props.treeData, keyPath);
                            keyPath.reverse();

                            let sIcon = null;
                            if (aOrgTreeDataItem && Object.hasOwnProperty.call(aOrgTreeDataItem, 'iconUrl') && aOrgTreeDataItem.iconUrl)
                            {
                                try
                                {
                                    sIcon = aOrgTreeDataItem.iconUrl;
                                    // sIcon = DataCache.getInstance().getItem(aOrgTreeDataItem.iconUrl);
                                } catch (err)
                                {
                                    console.warn(err);
                                }
                            }

                            let bCheckbox = false;
                            if (bMultiSelect || (aTreeDataItem && 0 >= Object.keys(aTreeDataItem).length))
                            {
                                bCheckbox = true;
                            }
                            const sCheckboxId = this.generateCheckboxId(aOrgTreeDataItem);

                            const checkChecked = () =>
                            {
                                if (sCheckboxId && this.state.selected.find(aSelected =>
                                {
                                    return (aSelected.id === sCheckboxId) || sCheckboxId.includes(aSelected.id);
                                }))
                                {
                                    return true;
                                }
                                return false;
                            }

                            return (
                                <div>
                                    {
                                        bCheckbox ?
                                            <input
                                                className="JsonTree__pointer"
                                                type="checkbox"
                                                id={sCheckboxId}
                                                checked={checkChecked()}
                                                onClick={(aEvent) =>
                                                {
                                                    aEvent.stopPropagation();
                                                }}
                                                onChange={(aEvent) =>
                                                {
                                                    this.checkboxChange(aEvent, {
                                                        keyPath: keyPath
                                                    });
                                                }}
                                            /> :
                                            null
                                    }
                                    {sIcon &&
                                        <img src={sIcon} />
                                    }
                                    {' '}
                                    <label className="JsonTree__pointer" htmlFor={sCheckboxId}>
                                        {keyPath[0]}
                                    </label>
                                </div>
                            );
                        }}
                        getItemString={() => { return null }}
                    /> :
                    null
                }
            </div>
        )
    }
}